import { useQueryClient } from '@tanstack/react-query'
import { useEffect } from 'react'
import { orgIntegrationsQueryKeys } from 'src/queries/queries.constants'

interface RelinkOrgIntegrationProps {
  linkUrl: string
  onClose: () => void
}

const RelinkOrgIntegration: React.FC<RelinkOrgIntegrationProps> = ({
  linkUrl,
  onClose,
}) => {
  const queryClient = useQueryClient()

  useEffect(() => {
    window.open(linkUrl, '_blank')

    const handleFocus = (): void => {
      queryClient.invalidateQueries({ queryKey: orgIntegrationsQueryKeys.all })
      onClose()
    }

    window.addEventListener('focus', handleFocus)
    return () => {
      window.removeEventListener('focus', handleFocus)
    }
  }, [linkUrl])

  return null
}

export default RelinkOrgIntegration
